import { createSlice } from '@reduxjs/toolkit'

export const plansSlice = createSlice({
  name: 'plans',
  initialState: {
    showCheckout: false,
    defaultPlanId: '',
    landingType: 'fullPrice',
    plan: '',
    upsellPlan: '',
    stripeObj: null,
    prices: {
      monthlyPrice: null,
      paymentPrice: null
    },
    couponDetails: {
      couponPrice: 0,
      couponName: ''
    }
  },
  reducers: {
    setDefaultPlanId: (state, action) => {
      state.defaultPlanId = action.payload
    },
    setShowCheckout: (state, action) => {
      state.showCheckout = action.payload
    },
    setLandingType: (state, action) => {
      state.landingType = action.payload || 'fullPrice'
    },
    setPlan: (state, action) => {
      state.plan = action.payload
    },
    setUpsellPlan: (state, action) => {
      state.upsellPlan = action.payload
    },
    setStripeObj: (state, action) => {
      state.stripeObj = action.payload;
    },
    setPlanPrices: (state, action) => {
      state.prices = action.payload;
    },
    setCouponDetails: (state, action) => {
      state.couponDetails = action.payload;
    },
  },
})

export const { setPlan, setLandingType, setStripeObj, setPlanPrices, setShowCheckout, setDefaultPlanId, setCouponDetails } = plansSlice.actions

export const selectShowCheckout = (state) => state.plans.showCheckout
export const selectDefaultPlanId = (state) => state.plans.defaultPlanId
export const selectPlan = (state) => state.plans.plan
export const selectUpsellPlan = (state) => state.plans.upsellPlan
export const selectLandingType = (state) => state.plans.landingType
export const selectStripeObj = state => state.plans.stripeObj;
export const selectPlanPrices = state => state.plans.prices;
export const selectPlanCoupon = state => state.plans.couponDetails;

export const { setUpsellPlan } = plansSlice.actions

export default plansSlice.reducer
